import {TPollId} from '../../../types/TBrandNumbers';

window['Gateway'] ??= {};
const Gateway = window['Gateway'];
Gateway.UI = Gateway.UI || {};

Gateway.UI.Polls = {
  getValidationReport: function (pollId: TPollId, onSuccess: (json: unknown) => void, onError?: (error: unknown) => void): void {
    window.Browser!.send('/ui/polls/' + pollId + '/validationReport', null, onSuccess, onError);
  },
};
